import { render } from "./EditAppointmentType.vue?vue&type=template&id=5e7afada&scoped=true&ts=true"
import script from "./EditAppointmentType.vue?vue&type=script&lang=ts"
export * from "./EditAppointmentType.vue?vue&type=script&lang=ts"

import "./EditAppointmentType.vue?vue&type=style&index=0&id=5e7afada&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7afada"]])

export default __exports__